import { render, staticRenderFns } from "./ValidationFormGroup.vue?vue&type=template&id=08d18502&"
import script from "./ValidationFormGroup.vue?vue&type=script&lang=js&"
export * from "./ValidationFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports